import { POGO_COLOURS } from "@/config/pogoConfig";

// Bag memory — persists cart lines across refreshes/navigation.
// Stored compactly (colourId, size, qty); rehydrated against POGO_COLOURS.
export const CART_STORAGE_KEY = "posso_cart_v1";

export function readStoredCart() {
  try {
    const raw = JSON.parse(localStorage.getItem(CART_STORAGE_KEY)) || [];
    return raw
      .map((l) => ({
        colour: POGO_COLOURS.find((c) => c.id === l.colourId),
        size: l.size,
        qty: l.qty,
      }))
      .filter((l) => l.colour && l.size && l.qty > 0);
  } catch {
    return [];
  }
}

export function countStoredCart() {
  return readStoredCart().length;
}
